var map = {
	"./bg-ticket.jpg": "56bb",
	"./covid19.jpg": "3622",
	"./covid5.jpg": "27ae",
	"./henkel-belenes.jpg": "8705",
	"./henkel-cedis-gdl.jpg": "0867",
	"./henkel-little.jpg": "72fc",
	"./henkel-logo-standalone-svg.svg": "4178",
	"./henkel-natco.jpg": "7397",
	"./henkel-tesistan.jpg": "4d77",
	"./qrcode.png": "10a6",
	"./resource-henkel.jpg": "29df",
	"./site-belenes-alt1.jpg": "aa1d",
	"./site-belenes.jpg": "f7cf",
	"./site-cedis-gdl.jpg": "0206",
	"./site-natco.jpg": "9e3f",
	"./site-tesistan.jpg": "0267"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";